import _ from 'lodash'

import {
  DESCARTAR_FOTO_USUARIO_RECUPERADA,
  FOTO_USUARIO_AUTENTICADO_RECUPERADA,
  INFORMACOES_CONTEXTO_APLICACAO_RECUPERADAS
} from '../actions/contextoAplicacaoActions'
import { USER_LOGOUT } from '../actions/authenticationJwtActions'

const INITIAL_STATE = {}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case INFORMACOES_CONTEXTO_APLICACAO_RECUPERADAS:
      const {
        codigoUsuario,
        codigoPessoaVinculoEmpreg,
        unidades,
        unidadeVinculacaoHierarquicaUsuario,
        visao,
        linksExternos,
        linksPrincipais,
        totalRepresentacoesPendentesAutuacao
      } = action.payload
      return {
        codigoUsuario,
        codigoPessoaVinculoEmpreg,
        unidadeVinculacaoHierarquica: unidadeVinculacaoHierarquicaUsuario,
        usuarioSemVisaoUnidade: _.size(unidades?.opcoes) === 0,
        unidades: _.keyBy(unidades?.opcoes, (unidade) => unidade.codigoUnidade),
        visao,
        linksExternos,
        linksPrincipais,
        totalRepresentacoesPendentesAutuacao
      }
    case FOTO_USUARIO_AUTENTICADO_RECUPERADA: {
      return {
        ...state,
        fotoUsuario: action.payload
      }
    }
    case DESCARTAR_FOTO_USUARIO_RECUPERADA:
      return { ...state, fotoUsuario: undefined }
    case USER_LOGOUT:
      return INITIAL_STATE
    default:
      return state
  }
}
